
import { Component, Vue, Watch } from "vue-property-decorator";
import { Toast } from "vant";
import { UserService, PageService } from "src/services";
import { tools } from "src/utils";
import { setColorOpacity } from "src/utils/extends";

@Component
export default class App extends Vue {
  /**
   * loading次数
   * @private
   * @returns string
   */
  private get loadingCount(): number {
    return this.$store.state.loadingCount || 0;
  }

  /**
   * 主题配置
   * @private
   * @returns any
   */
  private get properties(): any {
    return this.$store.state.properties || {};
  }

  /**
   * 主题配置
   * @private
   * @returns any
   */
  private get styleVars(): any {
    return {
      "--color": this.properties.fontColor,
      "--button-color": this.properties.buttonColor,
      "--background-color": this.properties.backgroudColor,
      "--background": this.properties.background,
      "--font-bg-color": this.properties.fontColor
        ? setColorOpacity(this.properties.fontColor, 0.14)
        : "rgba(59, 196, 169, 0.14)",
    };
  }

  /**
   * 当路由发生变化的时候操作。
   * @protected
   * @param {any} - to 当前路由实例。
   * @returns {void}
   */
  @Watch("$route", { deep: true, immediate: true })
  protected updateOpen(to: any): void {
    this.$store.dispatch("setLoadingCount", -1);
    let whiteName = ["login", "verification"];
    if (whiteName.indexOf(to.name) === -1 && to.name) {
      if (tools.isWechat()) {
        let openid = localStorage.getItem("openid");
        if (!this.$route.query.openid && !openid) {
          this.wechatOauth();
        } else if (this.$route.query.openid) {
          localStorage.setItem("openid", this.$route.query.openid as string);
        }
      }
    }
  }

  /**
   * 微信授权
   * @private
   * @returns void
   */
  private async wechatOauth(): Promise<void> {
    let url = location.href;

    try {
      let { content: result } = await UserService.instance.wechatOauth(url);
      if (result && result.data) {
        location.href = result.data;
      }
    } catch (err) {
      console.log(err);
    }
  }

  /**
   * 获取首页配置信息
   * @private
   * @returns void
   */
  private async getThemeConfig(): Promise<void> {
    try {
      // 主题配置类型
      let pageType = 1;
      let { content: result } = await PageService.instance.getPage({ pageType });
      if (result.data) {
        this.$store.dispatch("setProperties", result.data.properties);
      }
    } catch (err) {
      Toast(JSON.stringify(err));
    }
  }

  protected created() {
    this.getThemeConfig();
  }
}
